// extracted by mini-css-extract-plugin
export default {"App":"App_App__7BBxi","container":"App_container__mB9ij","unauthenticated-text":"App_unauthenticated-text__c54SC"};